module.exports = "Welcome to DAPNET Web!"


//////////////////
// WEBPACK FOOTER
// ./src/store/config/defaultText.json
// module id = 7S5r
// module chunks = 1